<template>
  <div>
    <div>
      <div class="row flow-text">
        <div class="col s12 m3 l3" id="name-text">
          <h5 id="name-text">Harrisen Sanchez</h5>
        </div>
        <div class="col s12 m2 l5"></div>
        <div class="col s12 m7 l4">
          <ul class="normal-nav">
            <li v-for="(link, index) in links" :key="index">
              <router-link
                v-if="pathString == link.name"
                class="nav-link-active"
                :to="{name: link.pathName}"
                exact
              >{{link.name}}</router-link>
              <router-link v-else class="nav-link" :to="{name: link.pathName}" exact>{{link.name}}</router-link>
              <span v-show="index != links.length-1">|</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <ul id="slide-out" class="sidenav">
      <li v-for="(link, index) in links" :key="index">
        <router-link
          v-if="pathString == link.name"
          class="side-nav-link"
          :to="{name: link.pathName}"
          exact
        >{{link.name}}</router-link>
        <router-link v-else class="nav-link" :to="{name: link.pathName}" exact>{{link.name}}</router-link>
        <span v-show="index != links.length-1">
          <hr />
        </span>
      </li>
    </ul>
    <!-- <a href="#" data-target="slide-out" class="sidenav-trigger">
      <i class="material-icons">menu</i>
    </a>-->
  </div>
</template>

<script>
export default {
  name: "SimpleNavComponent",
  data() {
    return {
      pathString: "",
      links: [
        {
          name: "Home",
          pathName: "OtherHomePage"
        },
        {
          name: "Works",
          pathName: "EnterpriseProjectsPage"
        },
        {
          name: "About",
          pathName: "AboutPage"
        },
        // {
        //   name: "Extra",
        //   pathName: "ExtraPage"
        // }
      ]
    };
  },
  beforeMount() {
    var path = this.$route.path;
    path = path.replace("/", "");
    // console.log(path);
    var afterWithout = path.substr(0, path.lastIndexOf("/"));
    console.log(afterWithout);
    this.pathString = afterWithout.length > 0 ? afterWithout : path;

    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".sidenav");
      var instances = M.Sidenav.init(elems, {});
    });
  }
};
</script>

<style scoped>
#name-text {
  color: #400101;
}

.normal-nav {
  margin: 0px;
  color: #000;
}
.normal-nav li {
  display: inline-block;
}
.normal-nav li .nav-link {
  color: #a60512;
}

.normal-nav li .nav-link:hover {
  color: #2e353b;
}
span {
  padding: 2px;
  margin: 2px;
}
.nav-link-active {
  text-decoration: underline;
  color: #a60512;
}
/* sidenav */

.sidenav {
  background: #2e353b;
}
.sidenav li {
  /* background: #f28787; */
  display: block;
  margin: 0px;
  padding: 0px;
  line-height: 0px;
  /* border-bottom: 2px solid #bf3944; */
}
.sidenav li a {
  color: whitesmoke;
}
.sidenav-overlay {
  background-color: rgba(0, 0, 0, 0.21);
}
.side-nav-link {
  display: block;
}
</style>
